module.exports = __webpack_public_path__ + "assets/img/gas.71943c0e.png";